import { render, staticRenderFns } from "./BlindPlateList.vue?vue&type=template&id=e6f6edcc&scoped=true"
import script from "./BlindPlateList.vue?vue&type=script&lang=js"
export * from "./BlindPlateList.vue?vue&type=script&lang=js"
import style0 from "./BlindPlateList.vue?vue&type=style&index=0&id=e6f6edcc&prod&lang=scss"
import style1 from "./BlindPlateList.vue?vue&type=style&index=1&id=e6f6edcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f6edcc",
  null
  
)

export default component.exports